var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.813,
    height: 24,
    viewBox: "0 0 19.813 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.2,7.021V1.378A1.974,1.974,0,0,0,62.153-.5H50.867a1.974,1.974,0,0,0-2.051,1.878v1.11H46.451A1.974,1.974,0,0,0,44.4,4.366V15.979h.009v5.643A1.974,1.974,0,0,0,46.46,23.5H57.746A1.974,1.974,0,0,0,59.8,21.622v-1.11h2.365a1.974,1.974,0,0,0,2.051-1.878V7.021H64.2Zm-1.054,0h-.009V18.634a.919.919,0,0,1-.988.82H59.8V10.008h-.009V4.366a1.974,1.974,0,0,0-2.051-1.878H49.888V3.546h7.858a.913.913,0,0,1,.988.82v5.643h-.009v10.5h0v1.11a.919.919,0,0,1-.988.82H46.451a.913.913,0,0,1-.988-.82V15.979h.009V4.366a.919.919,0,0,1,.988-.82h3.428V1.378a.919.919,0,0,1,.988-.82H62.162a.913.913,0,0,1,.988.82V7.021Z",
    transform: "translate(-44.4 0.5)",
    fill: "#1f1f28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.e6dc683a.svg";
export { ForwardRef as ReactComponent };